import DashboardPage from "pages/Dashboard/DashboardPage";
import MyFavoritePlanFormLayout from "layouts/MyFavoritePlanFormLayout";
import { MY_FAVORITE_PLAN_STEPS, buildFavPlanPath } from "constants/myFavoritePlanForm";
import BaseInformationStep from "pages/MyFavoritePlanForm/steps/BaseInformationStep";
import CoverageOptionsStep from "pages/MyFavoritePlanForm/steps/CoverageOptionsStep";
import DeductibleReductionStep from "pages/MyFavoritePlanForm/steps/DeductibleReductionStep";
import OutpatientBenefitsStep from "pages/MyFavoritePlanForm/steps/OutpatientBenefitsStep";
import PlanBenefitsStep from "pages/MyFavoritePlanForm/steps/PlanBenefitsStep";
import RidersMaternityStep from "pages/MyFavoritePlanForm/steps/RidersMaternityStep";
import RidersPreventiveCheckupStep from "pages/MyFavoritePlanForm/steps/RidersPreventiveCheckupStep";
import RidersEyeSurgeryStep from "pages/MyFavoritePlanForm/steps/RidersEyeSurgeryStep";
import SummaryStep from "pages/MyFavoritePlanForm/steps/SummaryStep";

const STEP_ELEMENTS = {
    'base-information':         <BaseInformationStep />,
    'coverage-options':         <CoverageOptionsStep />,
    'plan-benefits':            <PlanBenefitsStep />,
    'outpatient-benefits':      <OutpatientBenefitsStep />,
    'deductible-reduction':     <DeductibleReductionStep />,
    'riders-maternity':         <RidersMaternityStep />,
    'riders-preventive-checkup':<RidersPreventiveCheckupStep />,
    'riders-eye-surgery':       <RidersEyeSurgeryStep />,
    'summary':                  <SummaryStep />,
};

/**
 * Los mismos pasos se registran dos veces bajo el mismo layout:
 *   /fav-plan/<slug>       → crear un plan nuevo
 *   /fav-plan/:id/<slug>   → editar uno existente (el layout lo precarga)
 * Se generan desde MY_FAVORITE_PLAN_STEPS para no mantener la lista por duplicado.
 */
const stepRoutes = (id) => MY_FAVORITE_PLAN_STEPS.map(step => ({
    path: buildFavPlanPath(step.slug, id),
    element: STEP_ELEMENTS[step.slug],
}));

export const MyFavoritePlanRoutes = [
    { path: "/dashboard", element: <DashboardPage /> },
    {
        element: <MyFavoritePlanFormLayout />,
        children: [
            ...stepRoutes(),
            ...stepRoutes(':id'),
        ],
    },
]
